import Axios from 'axios'
import { SIGNING_JOB_STATUS } from '@/constant/constant'
import { get } from '@/utils/objectUtil'
import config from '@/config/config.js'
// import { isFieldBlank } from '../../utils/stringUtil'

// const baseUrl = 'http://192.168.119.122:8081/api/codetable'
// const baseUrl = '/b3/workflow/workflow/'
const baseUrl = config.apiDomain.ALI + '/ext/esign/workflow/'
const countPerActWorkItemUrl = baseUrl + 'countPersonalActiveWorkItems/'
const countPerActWorkItemsUrl = baseUrl + 'countPersonalActiveWorkItems' // only contains new flows
const countFollowingStaffTasksUrl = baseUrl + 'countFollowingStaffTasks' // {businessCode}
// duplicate with activeWorkItemsUrl
// const perActWorkItemUrl = baseUrl + 'personalActiveWorkItem/'
const activeWorkItemsUrl = baseUrl + 'personalActiveWorkItems/'
const historyWorkItemsUrl = baseUrl + 'personalHistoryWorkItems/'
const signAndStartWorkflowUrl = baseUrl + 'signAndStartWorkflow/' // /{businessCode}/{formCode}/{eSignOAuthCode} Sign and Start a workflow
const signAndCompleteUrl = baseUrl + 'signAndComplete/'
const getFollowingStaffsUrl = baseUrl + 'getFollowingStaffs' // /{businessCode}
const getFollowingStaffTasksUrl = baseUrl + 'getFollowingStaffTasks/' // /{businessCode}/{euid}
const getStaffFollowersUrl = baseUrl + 'staffFollowers/' // {euid}
const getPdfFromDmsUrl = baseUrl + 'getPdfFromDms/' // /{workItemId}/{formCode}
const staffFollowerUrl = baseUrl + 'staffFollower' // { startDate, endDate, followBy, euid}
const getAllPersonalActiveWorkItemCountsUrl = baseUrl + 'getAllPersonalActiveWorkItemCounts' // contains old workflow
// /{workItemId}/{assignedToStaffCode}/{action} Complete a task with next staff
// /{workItemId}/{action} Complete a task by automatically finding next staff
const completeUrl = baseUrl + 'complete/'

const completeInBatchUrl = baseUrl + 'completeInBatch'
const transferTaskToStaffUrl = baseUrl + 'transferTaskToStaff/' // /{workItemId}/{assignedToStaffCode}/    Reassign personal task to other staff
// /{businessCode} Start a workflow by automatically finding next staff
// /{businessCode}/{assignedToStaffCode}  Start a workflow
// const startWorkflowUrl = baseUrl + 'startWorkflow/'
const searchFormsUrl = baseUrl + 'searchFormsAndWorkflowStatus'
const personalActiveFormsWorkflowStatusUrl = baseUrl + 'personalActiveFormsAndWorkflowStatus'
const recallTaskUrl = baseUrl + 'recallTask/' // recall personal task
const idSignAndStartWorkflowUrl = 'identificationSignAndStartWorkflow'
const idSignAndCompleteUrl = baseUrl + 'identificationSignAndComplete'
const downloadPdfFromOssUrl = baseUrl + 'downloadPdfFromOss/'
const idBatchSignAndCompleteUrl = baseUrl + 'batchIdentificationSignAndComplete/' // {businessCode}/{auth_code}
const personalLastFormMetasUrl = baseUrl + 'getPersonalLastFormMetas/' // {businessCode}
const appliedPdfFromOssUrl = baseUrl + 'downloadAppliedPdfFromOss/' // {docCode} , for eLeave
const attachmentByFormCodeUrl = baseUrl + 'downloadAttachmentsByFormCode/'
const isJwtTokenTheApproverForApplicantUrl = baseUrl + 'isJwtTokenTheApproverForApplicant/' // {businessCode}/{applicantEuid}

Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
Axios.defaults.headers.timeout = 8000

const WAIT_FOR_CHECKING_SINGING_CART = 1 * 1000

export default {
  signAndStartWorkflowUrl,
  getPdfFromDmsUrl,
  idSignAndStartWorkflowUrl,
  idSignAndCompleteUrl,
  downloadPdfFromOssUrl,

  countPerActWorkItemByBusinessCode (cb, businessCode) {
    Axios.get(countPerActWorkItemUrl + businessCode).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  countPerActWorkItems (cb) {
    Axios.get(countPerActWorkItemsUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  countGroupsActiveWorkItems (cb) {
    Axios.get(baseUrl + 'countGroupsActiveWorkItems').then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  countGroupsActiveWorkItemsByBusiness (cb, businessCode) {
    Axios.get(baseUrl + 'countGroupsActiveWorkItems/' + businessCode).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  countFollowingStaffTasks (cb) {
    Axios.get(countFollowingStaffTasksUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getAllPerActiveWorkItemCounts (cb) {
    Axios.get(getAllPersonalActiveWorkItemCountsUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  // duplicate with getActiveItemsByBusinessCode
  // getPerActWorkItemsByBusinessCode (cb, businessCode) {
  //   Axios.get(perActWorkItemUrl + businessCode).then(
  //     response => {
  //       cb(response.data)
  //     },
  //     error => {
  //       console.error(error)
  //     }
  //   )
  // },

  getActiveItemsByBusinessCode (cb, businessCode, body) {
    Axios.post(activeWorkItemsUrl + businessCode, body).then(
      response => {
        if (response.status === 200) {
          cb(response.data)
        } else {
          cb()
        }
      },
      error => {
        console.error(error)
      }
    )
  },

  groupActiveWorkItems (cb, businessCode, groupId, body) {
    Axios.post(baseUrl + 'groupActiveWorkItems/' + businessCode + '/' + groupId, body).then(
      response => {
        if (response.status === 200) {
          cb(response.data)
        } else {
          cb()
        }
      },
      error => {
        console.error(error)
      }
    )
  },

  groupHistoryWorkItems (cb, businessCode, groupId, body) {
    Axios.post(baseUrl + 'groupHistoryWorkItems/' + businessCode + '/' + groupId, body).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getHistoryItemsByBusinessCode (cb, businessCode, body) {
    Axios.post(historyWorkItemsUrl + businessCode, body).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getFollowingStaffsByBusinessCode (cb, businessCode) {
    Axios.get(getFollowingStaffsUrl + '/' + businessCode).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  // get my following staffs
  getFollowingStaffs (cb) {
    Axios.get(getFollowingStaffsUrl).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  // get my following staff's tasks
  getFollowingStaffTasks (cb, businessCode, euid) {
    Axios.get(getFollowingStaffTasksUrl + businessCode + '/' + euid).then(
      response => {
        if (response.status === 200) {
          cb(response.data)
        } else {
          cb()
        }
      },
      error => {
        console.error(error)
      }
    )
  },

  // get staff's followers
  getStaffFollowers (cb, euid) {
    Axios.get(getStaffFollowersUrl + euid).then(
      response => {
        cb(response.data)
      },
      error => {
        console.error(error)
      }
    )
  },

  getPdfFromDms (cb, workItemId, formCode) {
    return new Promise((resolve, reject) => {
      Axios.get(getPdfFromDmsUrl + workItemId + '/' + formCode, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
        }
      )
    })
  },

  // body "formMetaMap" can be empty "{}"
  completeAutoFindNextStaff (cb, itemId, action, body) {
    Axios.post(completeUrl + itemId + '/' + action, JSON.stringify(body)).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        cb(error.response)
      }
    )
  },

  completeWithNextStaff (cb, itemId, action, body) {
    Axios.post(completeUrl + itemId + '/' + action, body).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        cb(error.response)
      }
    )
  },

  completeInBatch (cb, itemList) {
    Axios.post(completeInBatchUrl, itemList).then(
      response => {
        cb(response.status)
        // console.log(response.status)
      },
      error => {
        console.error(error)
        console.error(error.response.data)
      }
    )
  },

  transferTaskToStaff (cb, workItemId, euid, body) {
    // API's body is not a json object. So body must be null if no message is input by user.
    // can't use JSON.strignify(body)
    Axios.post(transferTaskToStaffUrl + workItemId + '/' + euid, body).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        // console.error(error)
        cb(error.response)
      }
    )
  },

  transferTask (cb, workItemId, body) {
    Axios.post(baseUrl + 'transferTask/' + workItemId, body).then(
      response => {
        cb(response)
        // console.log(response.status)
      },
      error => {
        // console.error(error)
        cb(error.response)
      }
    )
  },

  signAndStartWorkflow (cb, businessCode, formCode, eSignOAuthCode) {
    Axios.get(signAndStartWorkflowUrl + businessCode + '/' + formCode + '/' + eSignOAuthCode).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  countGroupActiveWorkItems (cb, businessCode, groupId) {
    Axios.get(baseUrl + 'countGroupActiveWorkItems/' + businessCode + '/' + groupId).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  signAndComplete (cb, eSignOAuthCode) {
    return new Promise((resolve, reject) => {
      Axios.post(signAndCompleteUrl + eSignOAuthCode, null,
        {
          headers: {
            'timeout': '600000'
          }
        }).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
        }
      )
    })
  },

  addStaffFollower (cb, body) {
    Axios.post(staffFollowerUrl, JSON.stringify(body)).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  deleteStaffFollower (cb, payload) {
    Axios.delete(staffFollowerUrl + '/' + payload.euid + '/' + payload.followedBy).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  searchForms (cb, body) {
    return new Promise((resolve, reject) => {
      Axios.post(searchFormsUrl, JSON.stringify(body)).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
        }
      )
    })
  },

  getPersonalActiveFormsWorkflowStatus (cb, body) {
    return new Promise((resolve, reject) => {
      Axios.post(personalActiveFormsWorkflowStatusUrl, JSON.stringify(body)).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
        }
      )
    })
  },

  personalFormsAndWorkflowStatus (cb, body) {
    return new Promise((resolve, reject) => {
      Axios.post(baseUrl + 'personalFormsAndWorkflowStatus', JSON.stringify(body)).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
        }
      )
    })
  },

  recallTask (cb, taskId, body) {
    return new Promise((resolve, reject) => {
      Axios.post(recallTaskUrl + taskId, body).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
        }
      )
    })
  },

  // deprecated
  downloadAttachmentsZip (attachmentTypeId, formAttributeId, workItemId, cb) {
    let body = {
      attachmentTypeId: attachmentTypeId,
      formAttributeId: formAttributeId,
      workItemId: workItemId
    }
    Axios.post(baseUrl + 'downloadAttachmentsZip', body, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  downloadAttachments (body, cb) {
    Axios.post(baseUrl + 'downloadAttachments', body, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  downloadAttachmentsByFormCode (formCode, cb) {
    Axios.post(attachmentByFormCodeUrl + formCode, null, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  rollbackTask (workItemId, body, cb) {
    Axios.post(baseUrl + 'rollbackTask/' + workItemId, body).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getFollowingStaffHistoryTasks (cb, businessCode, euid) {
    Axios.post(baseUrl + 'getFollowingStaffHistoryTasks/' + businessCode + '/' + euid, []).then(
      response => {
        cb(response.data)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getSignAndCompleteBatchStatus (cb, batchId) {
    Axios.get(baseUrl + 'getSignAndCompleteBatchStatus/' + batchId).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  waitForSigningJobComplete (cb, batchId) {
    this.getSignAndCompleteBatchStatus(resp => {
      let signingStatus = get(resp, 'data.status')
      if (signingStatus && (signingStatus === SIGNING_JOB_STATUS.ACTIVE)) {
        setTimeout(() => { this.waitForSigningJobComplete(cb, batchId) }, WAIT_FOR_CHECKING_SINGING_CART)
      } else {
        cb(resp)
      }
    }, batchId)
  },

  personalHistoryWorkItemsWithPaging (cb, keyword, pageNum, pageSize, businessCode, body) {
    return new Promise((resolve) => {
      let query = ''
      if (keyword) {
        query = '&keyword=' + encodeURI(keyword)
      }
      Axios.post(baseUrl + 'personalHistoryWorkItemsWithPaging/' + businessCode + '?pageNum=' + pageNum + '&pageSize=' + pageSize + query, body).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.log(error)
          cb(error.response)
        }
      )
    })
  },

  personalActiveWorkItemsWithPaging (cb, keyword, pageNum, pageSize, businessCode, body) {
    return new Promise((resolve) => {
      let query = ''
      if (keyword) {
        query = '&keyword=' + encodeURI(keyword)
      }
      Axios.post(baseUrl + 'personalActiveWorkItemsWithPaging/' + businessCode + '?pageNum=' + pageNum + '&pageSize=' + pageSize + query, body).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.log(error)
          cb(error.response)
        }
      )
    })
  },

  getFollowingStaffTasksWithPaging (cb, keyword, pageNum, pageSize, businessCode, euid) {
    return new Promise((resolve) => {
      let query = ''
      if (keyword) {
        query = '&keyword=' + encodeURI(keyword)
      }
      Axios.get(baseUrl + 'getFollowingStaffTasksWithPaging/' + businessCode + '/' + euid + '?pageNum=' + pageNum + '&pageSize=' + pageSize + query).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.log(error)
          cb(error.response)
        }
      )
    })
  },

  getFollowingStaffHistoryTasksWithPaging (cb, keyword, pageNum, pageSize, businessCode, euid) {
    return new Promise((resolve) => {
      let query = ''
      if (keyword) {
        query = '&keyword=' + encodeURI(keyword)
      }
      Axios.post(baseUrl + 'getFollowingStaffHistoryTasksWithPaging/' + businessCode + '/' + euid + '?pageNum=' + pageNum + '&pageSize=' + pageSize + query, []).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.log(error)
          cb(error.response)
        }
      )
    })
  },

  groupActiveWorkItemsWithPaging (cb, keyword, pageNum, pageSize, businessCode, groupId, body) {
    return new Promise((resolve) => {
      let query = ''
      if (keyword) {
        query = '&keyword=' + encodeURI(keyword)
      }
      Axios.post(baseUrl + 'groupActiveWorkItemsWithPaging/' + businessCode + '/' + groupId + '?pageNum=' + pageNum + '&pageSize=' + pageSize + query, body).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.log(error)
          cb(error.response)
        }
      )
    })
  },

  groupHistoryWorkItemsWithPaging (cb, keyword, pageNum, pageSize, businessCode, groupId, body) {
    return new Promise((resolve) => {
      let query = ''
      if (keyword) {
        query = '&keyword=' + encodeURI(keyword)
      }
      Axios.post(baseUrl + 'groupHistoryWorkItemsWithPaging/' + businessCode + '/' + groupId + '?pageNum=' + pageNum + '&pageSize=' + pageSize + query, body).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.log(error)
          cb(error.response)
        }
      )
    })
  },

  idSignAndComplete (cb, formCode, eSignOAuthCode) {
    return new Promise((resolve, reject) => {
      Axios.post(idSignAndCompleteUrl + formCode + '/' + eSignOAuthCode, null,
        {
          headers: {
            'timeout': '600000'
          }
        }).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          cb(error.response)
        }
      )
    })
  },

  // download pdf from OSS or DMS
  getPdfFromOss (cb, workItemId, formCode) {
    return new Promise((resolve, reject) => {
      Axios.get(downloadPdfFromOssUrl + workItemId + '/' + formCode, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        }
      }).then(
        response => {
          cb(response.data)
          resolve()
        },
        error => {
          console.error(error)
        }
      )
    })
  },

  getSignAndCompleteBatchStatusByBusinessCode (cb, businessCode) {
    Axios.get(baseUrl + 'getSignAndCompleteBatchStatusByBusinessCode/' + businessCode).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  idBatchSignAndComplete (cb, businessCode, authCode, data) {
    Axios.post(idBatchSignAndCompleteUrl + businessCode + '/' + authCode, data).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  getPersonalLastFormMetas (cb, businessCode) {
    Axios.get(personalLastFormMetasUrl + businessCode).then(
      response => {
        cb(response)
      },
      error => {
        console.log(error)
        cb(error.response)
      }
    )
  },

  getDocumentKey (cb, docCode, openerEuid) {
    return new Promise((resolve) => {
      Axios.get(baseUrl + 'documentKey/' + docCode + '/' + openerEuid).then(
        response => {
          cb(response)
          resolve()
        },
        error => {
          console.error(error)
        }
      )
    })
  },

  // for eLeave
  downloadAppliedPdfFromOss (docCode, cb) {
    Axios.get(appliedPdfFromOssUrl + docCode, {
      responseType: 'blob'
    }).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  isJwtTokenTheApproverForApplicant (businessCode, applicantEuid, cb) {
    Axios.get(isJwtTokenTheApproverForApplicantUrl + businessCode + '/' + applicantEuid).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  },

  insertDriveFileOpenerKey (cb, body) {
    Axios.post(baseUrl + 'insertDriveFileOpenerKey', body).then(
      response => {
        cb(response)
      },
      error => {
        cb(error.response)
      }
    )
  }

  //   completeTrainingStep (cb, itemList) {
  //     Axios.post(completeTSUrl, itemList).then(
  //       response => {
  //         cb(response.status)
  //         // console.log(response.status)
  //       },
  //       error => {
  //         console.error(error)
  //         console.error(error.response.data)
  //       }
  //     )
  //   }

}
